import React, {useState} from "react";
import { useFirebase } from "react-redux-firebase";
import '../../../styles/Dashboard.css'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {

  },
}));

const LettuceItem = () => {
  const firebase = useFirebase();

  const classes = useStyles();

  return (
    <div className='Overview'>
      <p>LettuceItem</p>
    </div>
  );
};
export default LettuceItem;
